import TimingClock from '../../components/TimingClock';
import { Button, Breadcrumb, Header } from '../../components';
import venueActions from '../../venue/actions';
import { bickActions } from '../../common';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { pick } from 'lodash';

class Timekeeper extends Component {
  onResetClick = event => {
    const { actions } = this.props;
    const { time } = event.target.dataset;
    actions.timingClock.reset(time);
  };

  onStartClick = () => {
    const { actions } = this.props;
    actions.timingClock.start();
  };

  onStopClick = () => {
    const { actions } = this.props;
    actions.timingClock.stop();
  };

  render() {
    //const { lifts, entries, sessions } = this.props;
    const { route, timingClock } = this.props;

    return (
      <main>
        <Breadcrumb>
          <Breadcrumb.Section as={Link} to={route.baseUrl}>
            Nosturi
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>Timekeeper</Breadcrumb.Section>
        </Breadcrumb>
        <Header as="h1">Timekeeper terminal</Header>
        <TimingClock {...timingClock} size="massive" />
        <Button
          data-time={60 * 1000}
          onClick={this.onResetClick}
          size="massive"
          primary
        >
          1 min
        </Button>
        <Button
          data-time={2 * 60 * 1000}
          onClick={this.onResetClick}
          size="massive"
          primary
        >
          2 min
        </Button>
        <Button
          content="Start"
          icon="play"
          onClick={this.onStartClick}
          size="massive"
          positive
        />
        <Button
          content="Stop"
          icon="pause"
          onClick={this.onStopClick}
          size="massive"
          negative
        />
        <br />
        <Button
          data-time={5 * 60 * 1000}
          onClick={this.onResetClick}
          size="big"
        >
          5:00
        </Button>
        <Button
          data-time={10 * 60 * 1000}
          onClick={this.onResetClick}
          size="big"
        >
          10:00
        </Button>
        <Button
          data-time={15 * 60 * 1000}
          onClick={this.onResetClick}
          size="big"
        >
          15:00
        </Button>
      </main>
    );
  }
}

Timekeeper.slug = 'timekeeper';
Timekeeper.title = 'Timekeeper';

const mapStateToProps = state => pick(state.venue.competition, 'timingClock');

const mapDispatchToProps = dispatch => ({
  actions: bickActions(venueActions.competition, ['timingClock'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Timekeeper);



// WEBPACK FOOTER //
// ./src/terminals/Timekeeper/index.js